<template>
  <div>
    <div class="list">
      <div class="breadcrumb" style="height: 40px">
        <Breadcrumb>
          <Breadcrumb-item href="#">财务管理</Breadcrumb-item>
          <Breadcrumb-item>应开发票</Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
    <div style="margin-bottom:10px">
      <div style="height: 30px">
        <span style="margin: 10px">合计金额：{{this.totalHasPayAmount}}</span>
        <span style="margin: 10px">已开发票金额：{{this.totalInvoiceAmount}}</span>
        <span style="margin: 10px">未开发票金额：{{this.notTotalInvoiceAmount}}</span>
      </div>
      <Form :label-width="80" label-position="left">
        <Row :gutter="32">
          <i-col span="6">
          <FormItem label="开票时间：">
            <Row>
              <i-col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                          @on-change="beginTimeChange"
                          v-model="queryParam.beginTime" style="width: 100%;"></Date-picker>
              </i-col>
              <i-col span="1" style="text-align: center">-</i-col>
              <i-col span="11">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                          @on-change="endTimeChange"
                          v-model="queryParam.endTime" style="width: 100%;"></Date-picker>
              </i-col>
            </Row>
          </FormItem>
          </i-col>

          <i-col span="6">
          <FormItem label="开票状态：">
            <Select  v-model.number="queryParam.invoiceState" clearable placeholder="请选择">
              <Option :value="1">未开</Option>
              <Option :value="2">部分已开</Option>
              <Option :value="3">已开</Option>
              <Option :value="-1">全部</Option>
            </Select>
          </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="发票类型：">
              <Select v-model.number="queryParam.state" clearable placeholder="请选择">
                <Option :value="1">收据</Option>
                <Option :value="2">普通发票</Option>
                <Option :value="3">增值税发票</Option>
                <Option :value="4">服务发票</Option>
                <Option :value="-1">全部</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="6">
          <Form-item label="学员ID：" :label-width="80">
            <Input placeholder="学生id" v-model="queryParam.uid"></Input>
          </Form-item>
          </i-col>
          <i-col span="6">
          <Form-item label="学员姓名：" :label-width="80">
            <Input placeholder="学生姓名" v-model="queryParam.nickname"></Input>
          </Form-item>
          </i-col>
          <i-col span="2">
            <Button type="primary" icon="search" style="margin-left: 30px" @click="search" :loading="searchLoading" :disable="searchLoading">搜索</Button>
          </i-col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :params="queryParam" :tableColumns="title" :listUrl="listUrl" :reload="reload" :onLoading="onLoading"></List>
    <EditInvoiceModal :value="editInvoice" :uid="uid" :invoiceDetail="invoiceDetail" :orderId="orderId" @on-close="closeModal" :successCallback="search"></EditInvoiceModal>
  </div>
</template>
<script>
  import EditInvoiceModal from './modal/EditInvoiceModal'
  export default {
    components: {
      EditInvoiceModal
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        totalInvoiceAmount: 0,
        totalHasPayAmount: 0,
        notTotalInvoiceAmount: 0,
        uid: null,
        orderId: null,
        invoiceDetail: null,
        editInvoice: false,
        listUrl: '/financial/invoiceList',
        queryParam: {
          uid: '',
          nickname: '',
          state: '',
          invoiceState: '',
          beginTime: '',
          endTime: ''
        },
        title: [
          {
            title: '学生ID/姓名',
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + ' ' + row.nickname)
            }
          },
          {
            title: '订单号',
            align: 'center',
            key: 'orderId',
          },
          {
            title: '订单金额',
            align: 'center',
            key: 'payAmount'
          },
          {
            title: '已付金额',
            align: 'center',
            key: 'hasPayAmount'
          },
          {
            title: '开票状态',
            align: 'center',
            render: (h, params) => {
              let invoiceState = params.row.invoiceState
              let invoiceStateEnum = $constant.getEnum($constant.invoiceState, invoiceState)
              return h('div', invoiceStateEnum && invoiceStateEnum.text)
            }
          },
          {
            title: '已开票',
            align: 'center',
            key: 'invoiceAmount'
          },
          {
            title: '未开票',
            align: 'center',
            key: 'notInvoiceAmount'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this
              let row = params.row
              return h('div', [
                h('a', {on: {click: () => self.edit(row.uid, row.orderId, row.invoiceDetail)}}, '开票')
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      self.$http.get('/financial/invoiceSum').then(function (res) {
        if (res.data) {
          let data = res.data
          self.totalInvoiceAmount = data.totalInvoiceAmount
          self.totalHasPayAmount = data.totalHasPayAmount
          self.notTotalInvoiceAmount = data.notTotalInvoiceAmount
        }
      })
    },
    created: function () {
    },
    methods: {
      onLoading (loading) {
        this.searchLoading = loading
      },
      beginTimeChange (value) {
        this.queryParam.beginTime = value
      },
      endTimeChange (value) {
        this.queryParam.endTime = value
      },
      search () {
        this.reload = new Date().getTime()
      },
      edit (uid, orderId, invoiceDetail) {
        this.uid = uid
        this.orderId = orderId
        this.invoiceDetail = invoiceDetail
        this.editInvoice = true
      },
      closeModal (val) {
        this.reload = new Date().getTime()
        this.uid = null
        this.orderId = null
        this.invoiceDetail = null
        this.editInvoice = false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// InvoiceList.vue?568cb658